/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurementRequest } from './APIMeasurementRequest';
import {
    APIMeasurementRequestFromJSON,
    APIMeasurementRequestFromJSONTyped,
    APIMeasurementRequestToJSON,
} from './APIMeasurementRequest';

/**
 * The serializer that enables the high level PartViewSet. This is basically
 * a simple form of the ArticleSerializer that is optimized to work with
 * the automated quote generation feature.
 * @export
 * @interface APIPatchedPartUpdateRequest
 */
export interface APIPatchedPartUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPartUpdateRequest
     */
    partId?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPartUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPatchedPartUpdateRequest
     */
    weight?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPatchedPartUpdateRequest
     */
    length?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPatchedPartUpdateRequest
     */
    width?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPatchedPartUpdateRequest
     */
    height?: APIMeasurementRequest | null;
    /**
     * 
     * @type {APIMeasurementRequest}
     * @memberof APIPatchedPartUpdateRequest
     */
    volume?: APIMeasurementRequest | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPartUpdateRequest
     */
    manufacturingProcess?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPartUpdateRequest
     */
    material?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIPatchedPartUpdateRequest
     */
    treatments?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof APIPatchedPartUpdateRequest
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedPartUpdateRequest
     */
    qualityClass?: string;
    /**
     * The guest request that this article was created for.
     * @type {string}
     * @memberof APIPatchedPartUpdateRequest
     */
    guestRequest?: string | null;
    /**
     * 
     * @type {Blob}
     * @memberof APIPatchedPartUpdateRequest
     */
    technicalDrawing?: Blob;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIPatchedPartUpdateRequest
     */
    price?: { [key: string]: any; };
}

/**
 * Check if a given object implements the APIPatchedPartUpdateRequest interface.
 */
export function instanceOfAPIPatchedPartUpdateRequest(value: object): value is APIPatchedPartUpdateRequest {
    return true;
}

export function APIPatchedPartUpdateRequestFromJSON(json: any): APIPatchedPartUpdateRequest {
    return APIPatchedPartUpdateRequestFromJSONTyped(json, false);
}

export function APIPatchedPartUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedPartUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'partId': json['part_id'] == null ? undefined : json['part_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'weight': json['weight'] == null ? undefined : APIMeasurementRequestFromJSON(json['weight']),
        'length': json['length'] == null ? undefined : APIMeasurementRequestFromJSON(json['length']),
        'width': json['width'] == null ? undefined : APIMeasurementRequestFromJSON(json['width']),
        'height': json['height'] == null ? undefined : APIMeasurementRequestFromJSON(json['height']),
        'volume': json['volume'] == null ? undefined : APIMeasurementRequestFromJSON(json['volume']),
        'manufacturingProcess': json['manufacturing_process'] == null ? undefined : json['manufacturing_process'],
        'material': json['material'] == null ? undefined : json['material'],
        'treatments': json['treatments'] == null ? undefined : json['treatments'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'qualityClass': json['quality_class'] == null ? undefined : json['quality_class'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
        'technicalDrawing': json['technical_drawing'] == null ? undefined : json['technical_drawing'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}

export function APIPatchedPartUpdateRequestToJSON(value?: APIPatchedPartUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'part_id': value['partId'],
        'name': value['name'],
        'weight': APIMeasurementRequestToJSON(value['weight']),
        'length': APIMeasurementRequestToJSON(value['length']),
        'width': APIMeasurementRequestToJSON(value['width']),
        'height': APIMeasurementRequestToJSON(value['height']),
        'volume': APIMeasurementRequestToJSON(value['volume']),
        'manufacturing_process': value['manufacturingProcess'],
        'material': value['material'],
        'treatments': value['treatments'],
        'quantity': value['quantity'],
        'quality_class': value['qualityClass'],
        'guest_request': value['guestRequest'],
        'technical_drawing': value['technicalDrawing'],
        'price': value['price'],
    };
}

